import axios from 'axios'
import * as auth from './auth/auth'

import defaultOptions from './defaultoption'

const pagamento = {
  async getFormas(body) {
    return await fetch(
      `${process.env.REACT_APP_API_CHECKOUT}api/Pagamento/GetFormas`,
      {
        method: 'post',
        headers: defaultOptions.headers,
        body: JSON.stringify(body)
      }
    )
  },
  async getCartoes() {
    return await fetch(
      `${process.env.REACT_APP_API_CHECKOUT}api/Pagamento/GetCartoesSalvos`,
      {
        method: 'GET',
        headers: defaultOptions.headers
      }
    )
  },
  async addCartao(body) {
    // return await fetch(
    //   `${process.env.REACT_APP_API_CHECKOUT}api/Pagamento/AdicionarCartaov2`,
    //   {
    //     method: 'POST',
    //     headers: {
    //       Authorization: `Bearer ${auth.token()}`,
    //       'Content-Type': 'application/json; charset=utf-8',
    //       'Access-Control-Allow-Origin': '*'
    //     },
    //     body: JSON.stringify(body)
    //   }
    // )
    return axios
      .post(
        `${process.env.REACT_APP_API_CHECKOUT}api/Pagamento/AdicionarCartaov2`,
        body,
        {
          headers: {
            Authorization: `Bearer ${auth.token()}`,
            'Content-Type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin': '*'
          }
        }
      )
      .catch((error) => error.response)
  },
  async delCartao(token) {
    return await fetch(
      `${process.env.REACT_APP_API_CHECKOUT}api/Pagamento/ExcluirToken`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${auth.token()}`,
          'Content-Type': 'application/json; charset=utf-8',
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({ Token: token })
      }
    )
  },
  async getCupom(cupom) {
    return await fetch(
      `${process.env.REACT_APP_API_CHECKOUT}api/Cupom/GetCupom/${cupom}`,
      {
        method: 'POST',
        headers: defaultOptions.headers
      }
    )
  },
  async limpaCupom() {
    return await fetch(
      `${process.env.REACT_APP_API_CHECKOUT}api/Cupom/LimpaCupom`,
      {
        method: 'POST',
        headers: defaultOptions.headers
      }
    )
  },
  async getGimplus() {
    return await fetch(`${process.env.REACT_APP_API_CHECKOUT}api/Gimplus/Get`, {
      method: 'GET',
      headers: defaultOptions.headers
    })
  },
  async setGimplus(valor) {
    return await fetch(`${process.env.REACT_APP_API_CHECKOUT}api/Gimplus/Set`, {
      method: 'POST',
      headers: defaultOptions.headers,
      body: JSON.stringify({ ValorPontos: valor })
    })
  }
}

export default pagamento
